/*
  AquaNatura: „Mehr anzeigen"-Button (Load-More) für Collection-, Such- und Blog-Seiten.
  <infinite-scroll data-next-url="..." [data-grid-selector=".product-grid"]> umschliesst die
  Item-Liste + die Dawn-Pagination.

  Verhalten:
  - Ersetzt die nummerierte Pagination durch einen prominenten „Mehr anzeigen"-Button.
  - Klick lädt die nächste Seite per fetch nach und hängt die neuen Items an die Liste an.
  - data-next-url wird aus der nachgeladenen Seite übernommen; ist keine mehr da, verschwindet der Button.
  - Grid-Selektor generisch: `.product-grid` (Collection + Suche), `.blog-articles` (Blog) via data-grid-selector.
  - Facets-kompatibel: Dawns facets.js ersetzt #ProductGridContainer-innerHTML bei Filter/Sortierung.
    Der Wrapper wird dabei zerstört + neu erstellt -> connectedCallback re-initialisiert.
  - Fallback: ohne JS / bei einem Fehler bleibt die normale Pagination sichtbar.
*/
if (!customElements.get('infinite-scroll')) {
  customElements.define(
    'infinite-scroll',
    class InfiniteScroll extends HTMLElement {
      connectedCallback() {
        this.gridSelector = this.dataset.gridSelector || '.product-grid';
        this.grid = this.querySelector(this.gridSelector);
        this.nextUrl = this.dataset.nextUrl || null;
        this.loading = false;

        // Kein Grid oder keine Folgeseite -> normale Pagination als Fallback behalten.
        if (!this.grid || !this.nextUrl) return;

        this.classList.add('infinite-scroll--active');
        this.button = document.createElement('button');
        this.button.type = 'button';
        this.button.className = 'infinite-scroll__more';
        this.moreLabel = this.dataset.moreLabel || 'Mehr anzeigen';
        this.button.textContent = this.moreLabel;
        this.button.addEventListener('click', () => this.loadNext());
        this.appendChild(this.button);
      }

      async loadNext() {
        if (this.loading || !this.nextUrl || !this.button) return;
        this.loading = true;
        this.classList.add('infinite-scroll--loading');
        this.button.disabled = true;
        this.button.textContent = 'Lädt …';

        try {
          const res = await fetch(this.nextUrl);
          if (!res.ok) throw new Error('HTTP ' + res.status);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

          const newGrid = doc.querySelector(this.gridSelector);
          if (newGrid) {
            const frag = document.createDocumentFragment();
            newGrid.querySelectorAll(':scope > *').forEach((el) => {
              // Reveal-on-scroll-Klassen entfernen, damit nachgeladene Items sofort sichtbar sind
              // (Dawns Animations-Observer erfasst dynamisch eingefügte Elemente nicht).
              el.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
              el.removeAttribute('data-cascade');
              el.style.removeProperty('--animation-order');
              frag.appendChild(el);
            });
            this.grid.appendChild(frag);
          }

          // Nächste URL aus der nachgeladenen Seite übernehmen.
          const nextWrapper = doc.querySelector('infinite-scroll');
          this.nextUrl = nextWrapper ? nextWrapper.dataset.nextUrl || null : null;

          if (this.nextUrl) {
            this.button.disabled = false;
            this.button.textContent = this.moreLabel;
          } else {
            // Alles geladen: Button weg, aber --active behalten, damit die Pagination ausgeblendet bleibt.
            this.button.remove();
            this.button = null;
            this.classList.add('infinite-scroll--done');
          }
        } catch (e) {
          // Bei Fehler den Button entfernen und die normale Pagination wieder einblenden.
          if (this.button) this.button.remove();
          this.button = null;
          this.classList.remove('infinite-scroll--active');
          console.warn('[aq-load-more]', e);
        } finally {
          this.loading = false;
          this.classList.remove('infinite-scroll--loading');
        }
      }
    }
  );
}
